import { Card, Skeleton } from "../ui/feedback";
import { Logo } from "../ui/logo";

/**
 * The app's frame while sign-in is restored or a page's code loads: the sidebar, header and a
 * page of placeholders, so the screen never sits blank with a lone spinner.
 */
export function AppShellSkeleton() {
  return (
    <div className="min-h-dvh bg-canvas md:pl-[248px]" aria-busy="true">
      <span className="sr-only" role="status" aria-label="Loading Eduleo">
        Loading Eduleo
      </span>
      <div className="fixed inset-y-0 left-0 hidden w-[248px] flex-col gap-6 border-edge border-r bg-surface px-4 py-5 md:flex">
        <Logo />
        <Skeleton className="h-14 w-full rounded-lg" />
        <div className="flex flex-col gap-3">
          {[0, 1, 2, 3].map((item) => (
            <Skeleton key={item} className="h-8 w-full" />
          ))}
        </div>
      </div>
      <div className="flex h-16 items-center gap-3 border-edge border-b bg-surface px-4 md:px-6">
        <span className="md:hidden">
          <Logo />
        </span>
        <Skeleton className="ml-auto size-9 rounded-full" />
      </div>
      <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-5 px-4 pt-5 md:px-6 md:pt-6">
        <Skeleton className="h-7 w-56" />
        <Skeleton className="h-4 w-80 max-w-full" />
        <Card className="flex flex-col gap-4 p-5">
          {[0, 1, 2, 3, 4].map((row) => (
            <div key={row} className="flex items-center justify-between gap-4">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-4 w-1/5" />
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
